@if (workflow(); as wf) {
  <div class="flex flex-col h-full">
    <!-- ── Header ── -->
    <div
      class="flex flex-wrap items-center justify-between gap-lg border-b border-neutral-200 py-lg">
      <div class="flex items-center gap-md">
        <h1 class="text-2xl font-semibold text-neutral-900">{{ title() }}</h1>
        <lib-badge
          [label]="'custom_workflow_status_' + wf.status | transloco"
          [badgeClass]="
            wf.status === Status.Published
              ? 'px-sm border-none text-sm font-medium bg-success-50 text-success-700'
              : 'px-sm border-none text-sm font-medium bg-neutral-100 text-neutral-700'
          " />
        @if (wf.locked) {
          <lib-badge
            [label]="'custom_workflow_locked_badge' | transloco"
            [badgeClass]="'px-sm border-none text-sm font-medium bg-warning-50 text-warning-700'" />
        }
      </div>
      <div class="flex flex-wrap items-center gap-md">
        <lib-button
          id="custom_workflow_preview_button"
          [label]="'custom_workflow_preview_button' | transloco"
          [btnClass]="secondaryBtn"
          (click)="openPreview()" />
        @if (!readonly()) {
          <lib-button
            id="custom_workflow_duplicate_button"
            [label]="'custom_workflow_duplicate_button' | transloco"
            [btnClass]="secondaryBtn"
            (click)="duplicate()" />
          <lib-button
            id="custom_workflow_active_button"
            [disabled]="isBusy()"
            [label]="
              (wf.is_active
                ? 'custom_workflow_deactivate_button'
                : 'custom_workflow_activate_button'
              ) | transloco
            "
            [btnClass]="wf.is_active ? destructiveBtn : primaryBtn"
            (click)="toggleActive()" />
        }
      </div>
    </div>

    <!-- ── SVG icon templates for tabs ── -->
    <ng-template #canvasTabIcon>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round">
        <rect x="1" y="1" width="12" height="12" rx="2" />
        <path d="M4 5h6M4 7h4" />
      </svg>
    </ng-template>
    <ng-template #formTabIcon>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round">
        <rect x="1.5" y="1.5" width="11" height="11" rx="1.5" />
        <path d="M4 5h6M4 7h6M4 9h3" />
      </svg>
    </ng-template>
    <ng-template #settingsTabIcon>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round">
        <circle cx="7" cy="7" r="2" />
        <path
          d="M7 1v2M7 11v2M1 7h2M11 7h2M2.93 2.93l1.41 1.41M9.66 9.66l1.41 1.41M2.93 11.07l1.41-1.41M9.66 4.34l1.41-1.41" />
      </svg>
    </ng-template>

    <!-- ── Tabs ── -->
    <lib-tabs
      class="flex-1 min-h-0"
      [tabsBorder]="true"
      [(activeTabIndex)]="activeTabIndex">
      <!-- Canvas tab -->
      <lib-tab
        id="custom_workflow_tab_canvas"
        [tabTitle]="'custom_workflow_tab_canvas' | transloco"
        [tabTemplateSvgIcon]="canvasTabIcon">
        <lib-custom-workflow-canvas-tab
          [workflow]="wf"
          [readonly]="readonly()"
          [publishErrors]="publishErrors()"
          (changed)="onEditorChanged()"
          (apiError)="onApiError($event)" />
      </lib-tab>

      <!-- Request Form tab -->
      <lib-tab
        id="custom_workflow_tab_form"
        [tabTitle]="'custom_workflow_tab_request_form' | transloco"
        [tabTemplateSvgIcon]="formTabIcon"
        [showTabTag]="boxErrors().noFields"
        [tabTag]="'!'">
        <div class="pt-2xl">
          <lib-custom-workflow-form-editor
            #editor
            [workflow]="wf"
            [readonly]="readonly()"
            (changed)="onEditorChanged()"
            (apiError)="onApiError($event)" />
        </div>
      </lib-tab>

      <!-- Settings tab -->
      <lib-tab
        id="custom_workflow_settings_button"
        [tabTitle]="'custom_workflow_settings_button' | transloco"
        [tabTemplateSvgIcon]="settingsTabIcon"
        [showTabTag]="boxErrors().nobodyCanSubmit"
        [tabTag]="'!'">
        <div class="pt-2xl">
          <lib-custom-workflow-settings
            #editor
            [workflow]="wf"
            [readonly]="readonly()"
            (changed)="onEditorChanged()"
            (apiError)="onApiError($event)" />
        </div>
      </lib-tab>
    </lib-tabs>
  </div>
} @else {
  <lib-overlay-loader />
}

<ng-template #preview
  ><lib-custom-workflow-preview [workflowId]="id"
/></ng-template>
